module.exports = __webpack_public_path__ + "static/media/Audino_gaussian2.eede11a6.png";